import React, { Component } from 'react';
// import PropTypes from 'prop-types';

import { Query } from 'react-apollo';
import { PERSON_QUERY } from '../graphql';

import Person from 'components/Person';

export class PersonPage extends Component {
  render() {
    const { error, loading, person, refetchQueries } = this.props;

    if (loading) return 'Loading...';

    return (
      <div style={{ paddingTop: 10 }}>
        {/* <pre>{JSON.stringify(this.props, null, 2)}</pre> */}
        <Person person={person} refetchQueries={refetchQueries} />
      </div>
    );
  }
}

// https://reactjs.org/docs/typechecking-with-proptypes.html#proptypes
// PersonPage.propTypes = {};

export default props => (
  <Query query={PERSON_QUERY} variables={{ id: props.match.params.id }}>
    {({ loading, error, data }) => (
      <PersonPage
        {...props}
        refetchQueries={[
          {
            query: PERSON_QUERY,
            variables: { id: props.match.params.id },
          },
        ]}
        loading={loading}
        error={error}
        person={data && data.person}
      />
    )}
  </Query>
);



// WEBPACK FOOTER //
// ./src/pages/PersonPage.js